"use client";

import { useEffect } from "react";

import {
  SecondaryListingData,
  useListingData,
} from "~/context/ListingPageDataContext";

export function SecondaryDataUpdater({ data }: { data: SecondaryListingData }) {
  const { updateData } = useListingData();

  useEffect(() => {
    if (data) {
      updateData(data, true);
    }
  }, [data, updateData]);

  return null;
}
